import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
const FinalViewWithoutRating = (props) => {
  return /* @__PURE__ */ jsxs("div", { id: "chat-view", className: "final-view final-view-no-rating", children: [
    /* @__PURE__ */ jsx("h3", { children: "Thanks for chatting with us today!" }),
    /* @__PURE__ */ jsxs("div", { className: "section final-message", children: [
      /* @__PURE__ */ jsx("p", { children: "We hope we were able to answer all your questions. If you have any further inquiries, please don't hesitate to contact us again." }),
      /* @__PURE__ */ jsx("p", { children: "Have a great day!" })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "section button-container", children: /* @__PURE__ */ jsx(
      "button",
      {
        className: `button light-red-gradient`,
        onClick: props.onButtonClick,
        children: "CLOSE"
      }
    ) })
  ] });
};
FinalViewWithoutRating.propTypes = {
  businessUnit: PropTypes.number,
  onButtonClick: PropTypes.func
};
export {
  FinalViewWithoutRating as default
};
//# sourceMappingURL=FinalViewWithoutRating.js.map
